import React, { memo } from 'react';

import useBooleanState from '@/hooks/useBooleanState';
import useElementEvent from '@/hooks/useElementEvent';

import Button from '@/components/UI/Button';
import Modal from '@/components/UI/Modal';
import Icon from '@/components/UI/Icon';

interface ObjectVideoModalProps {
  buttonId: string;
  videoUrl: string;
}

const ObjectVideoModal = ({
  buttonId,
  videoUrl
}: ObjectVideoModalProps) => {
  const {
    isOpen,
    open: openModal,
    close: closeModal
  } = useBooleanState();

  useElementEvent(buttonId, openModal);

  return (
    <Modal
      overlayClassName="object-modal-overlay"
      isOpen={isOpen}
      onRequestClose={closeModal}
    >
      <div className="object-video-iframe">
        {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
        <iframe
          width="100%"
          height="100%"
          src={videoUrl}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>

      <div className="object-modal-wrapper">
        <Button
          aria-label="Close"
          className="ReactModal__Close"
          onClick={closeModal}
        >
          <Icon
            name="Close"
            width={32}
            height={32}
            color="#FFF"
          />
        </Button>
      </div>
    </Modal>
  );
};

export default memo(ObjectVideoModal);
